import type { RootState } from './Store';

export const selectConnectionState = (state: RootState) => {
  const { robotData, robot } = state;
  return {
    robotType: robotData.robotType,
    robotName: robotData.robotName,
    connectionType: robot.connectionType,
    robotState: robot.robotState,
  };
};

export const selectFirmwareState = (state: RootState) => state.robot.firmware.firmwareState;
export const selectFirmwareProgress = (state: RootState) => state.robot.firmware.progress;
export const selectFirmwareStatus = (state: RootState) => state.robot.firmware.status;
